import { render, staticRenderFns } from "./PsotList.vue?vue&type=template&id=2f0ce461&scoped=true&"
import script from "./PsotList.vue?vue&type=script&lang=js&"
export * from "./PsotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0ce461",
  null
  
)

export default component.exports